import { defineMessages } from 'react-intl';

export const companyTimelineMessages = defineMessages({
	timelineLabel: {
		id: 'company-timeline.timelineLabel',
		defaultMessage: 'Company history timeline',
	},
	heading: {
		id: 'company-timeline.heading',
		defaultMessage: 'A brief history',
	},
	introFounding: {
		id: 'company-timeline.introFounding',
		defaultMessage:
			"Armed with a credit card and a dream, two college friends, Mike Cannon-Brookes and Scott Farquhar set out to create Atlassian. In 2002, they didn't know what kind of company Atlassian was going to be, but they knew exactly what it shouldn't be—an environment where they had to conform rather than be who they authentically are.",
	},
	introToday: {
		id: 'company-timeline.introToday',
		defaultMessage:
			"Now 20 years in, we've grown into a global company with employees all over the world, but those early ambitions hold true. Here's our story:",
	},
	entry1998: {
		id: 'company-timeline.entry1998',
		defaultMessage:
			'Mike and Scott, both 18, land in the same scholarship course at the University of New South Wales.',
	},
	entry2001: {
		id: 'company-timeline.entry2001',
		defaultMessage: 'Atlassian, inspired by the Greek Titan, is registered as a business name.',
	},
	entry2002: {
		id: 'company-timeline.entry2002',
		defaultMessage: 'Atlassian becomes real with the launch of Jira 1.0.',
	},
	entry2003: {
		id: 'company-timeline.entry2003',
		defaultMessage: 'Confluence 1.0 is born and released to the world.',
	},
	entry2005Highlight: {
		id: 'company-timeline.entry2005Highlight',
		defaultMessage: '1,000',
	},
	entry2005: {
		id: 'company-timeline.entry2005',
		defaultMessage: 'We get our 1,000th customer.',
	},
	entry2006: {
		id: 'company-timeline.entry2006',
		defaultMessage: 'We co-found Pledge 1% and Atlassian Foundation is created.',
	},
	entry2007: {
		id: 'company-timeline.entry2007',
		defaultMessage: 'Our five core values come to life.',
	},
	entry2007Value1: {
		id: 'company-timeline.entry2007Value1',
		defaultMessage: 'Open company, no bullshit.',
	},
	entry2007Value2: {
		id: 'company-timeline.entry2007Value2',
		defaultMessage: 'Build everything with heart and balance.',
	},
	entry2007Value3: {
		id: 'company-timeline.entry2007Value3',
		defaultMessage: "Don't #@!% the customer.",
	},
	entry2007Value4: {
		id: 'company-timeline.entry2007Value4',
		defaultMessage: 'Play as a team.',
	},
	entry2007Value5: {
		id: 'company-timeline.entry2007Value5',
		defaultMessage: 'Be the change you seek.',
	},
	entry2009: {
		id: 'company-timeline.entry2009',
		defaultMessage: 'We open our first European office in Amsterdam.',
	},
	entry2011: {
		id: 'company-timeline.entry2011',
		defaultMessage: 'Atlassian ships first cloud versions of Confluence and Jira.',
	},
	entry2012Highlight: {
		id: 'company-timeline.entry2012Highlight',
		defaultMessage: '10 years!',
	},
	entry2012Anniversary: {
		id: 'company-timeline.entry2012Anniversary',
		defaultMessage: 'Atlassian celebrates its 10th anniversary.',
	},
	entry2012Revenue: {
		id: 'company-timeline.entry2012Revenue',
		defaultMessage: 'We hit $100 million dollars of revenue.',
	},
	entry2013Offices: {
		id: 'company-timeline.entry2013Offices',
		defaultMessage: 'We open offices in Yokohama and Manila.',
	},
	entry2013ServiceDesk: {
		id: 'company-timeline.entry2013ServiceDesk',
		defaultMessage:
			"Jira Service Desk (a former ShipIt project!) joins Atlassian's suite of tools.",
	},
	entry2015: {
		id: 'company-timeline.entry2015',
		defaultMessage: 'Atlassian goes public! We are listed on NASDAQ as TEAM.',
	},
	entry2017: {
		id: 'company-timeline.entry2017',
		defaultMessage: 'Trello joins our growing family of tools.',
	},
	entry2018Opsgenie: {
		id: 'company-timeline.entry2018Opsgenie',
		defaultMessage: 'Opsgenie joins our product family.',
	},
	entry2018Bengaluru: {
		id: 'company-timeline.entry2018Bengaluru',
		defaultMessage: 'We opened our Bengaluru office.',
	},
	entry2020ServiceManagement: {
		id: 'company-timeline.entry2020ServiceManagement',
		defaultMessage:
			'We launched Jira Service Management, the next generation of Jira Service Desk.',
	},
	entry2020TeamAnywhere: {
		id: 'company-timeline.entry2020TeamAnywhere',
		defaultMessage:
			'Atlassian announces TEAM Anywhere, a distributed work policy that allows employees to work from (almost) anywhere.',
	},
	entry2021: {
		id: 'company-timeline.entry2021',
		defaultMessage: 'Launched Jira Work Management.',
	},
	entry2022Highlight: {
		id: 'company-timeline.entry2022Highlight',
		defaultMessage: '20 years!',
	},
	entry2022: {
		id: 'company-timeline.entry2022',
		defaultMessage: 'Celebrating 20 years!',
	},
	entry2023Ai: {
		id: 'company-timeline.entry2023Ai',
		defaultMessage: 'Introduced AI to Atlassian cloud platform.',
	},
	entry2023Loom: {
		id: 'company-timeline.entry2023Loom',
		defaultMessage: 'Atlassian acquires Loom.',
	},
	entry2024Rovo: {
		id: 'company-timeline.entry2024Rovo',
		defaultMessage: 'Announced Rovo, our AI teammate.',
	},
	entry2024Jira: {
		id: 'company-timeline.entry2024Jira',
		defaultMessage: 'Jira Software and Jira Work Management unite into Jira.',
	},
	entry2025: {
		id: 'company-timeline.entry2025',
		defaultMessage: 'Debut Strategy and Teamwork Collections.',
	},
});
